export enum NavOption {
    Collection,
    WishList,
    About,
  };